<template>
    <img v-lightbox="imageSrc" :src="thumbSrc" alt="">
</template>

<script type="text/babel">
export const LightboxTypes = {
  Image: 1,
  Video: 2,
};

export default {
  name: 'LightBoxImage',
  data() {
    return {
      thumbSize: 500,
      imageSize: 2000,
    };
  },
  props: {
    src: {
      required: true,
      type: String,
    },
  },
  computed: {
    thumbSrc() {
      if (this.src.indexOf('http') === false) {
        return this.src;
      }
      return `https://cms.pixel-kraft.de${this.getThumb(this.src, this.thumbSize)}`;
    },
    imageSrc() {
      if (this.src.indexOf('http') === false) {
        return this.src;
      }
      return `https://cms.pixel-kraft.de${this.getThumb(this.src, this.imageSize)}`;
    },
  },
  methods: {
    getThumb(url, size) {
      return url.replace(/(^(?!http)(?:(?!thumb).)*)\.(jpe?g|png|gif)/, `$1.${size}.$2`);
    },
  },
};
</script>

<style lang="scss">

</style>
